<template>
    <div class="mb-2 row">
        <label class="col-md-1 col-form-label">Airport</label>
        <div class="col-md-2">
            <select class="form-select form-select-sm" name="airport" v-model="selected" @change="updated($event.target.value)">
                <option value="" disabled></option>
                <option v-for="airport in airports" v-bind:value="airport.code">
                    {{airport.name}} ({{airport.code}})
                </option>
            </select>
            <span class="input-error" v-if="error" v-text="error"></span>
        </div>

    </div>
</template>

<script>
    export default {
        mounted() {
            this.airports = window.configValues.airports;
            if(this.airports.length == 1) {
              this.selected = this.airports[0].code
            }
        },
        props: {
            error: undefined

        },

        data() {
            return {
                airports: [],
                selected: ''

            }
        },
        computed: {


        },
        methods: {
            updated(airport) {
                this.$emit('input', airport);
            }
        }

    }
</script>
